import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import SideBar from "../components/SideBar/SideBar";
import GraphicTemplatesSideBarContent from "../components/TemplateSelection/GraphicTemplatesSideBarContent";
import ControlBar from "../components/TemplateSelection/ControlBar";
import AssetList from "../components/AssetList";
import { actions as assetActions } from "../actions/asset";
import { actions as assetsActions } from "../actions/assets";
import { actions as appActions } from "../actions/app";
import SidebarState from "../constants/sidebarState";
import App from "../constants/app";
import LuciPropTypes from "../propTypes/";
import Pagination from "../components/Pagination";
import AssetType from "../constants/assetTypes";
import {
  Container,
  MainContent,
  StickyHeader,
  StickyFooter
} from "../styled-components/Layout";
import Footer from "../components/Footer";

const PaginationContainer = styled.div`
  position: fixed;
  bottom: ${props => props.bottom || App.FOOTER_HEIGHT};
  right: 1.2rem;
  flex-direction: column;
`;

const MainContainer = styled(MainContent)`
  display: flex;
  flex-direction: row;
  height: 100%;
  background: ${props => props.theme.background};
`;

const SubContainer = styled(Container)`
  width: 100%;
`;

class TemplateLayout extends React.Component {
  constructor() {
    super();

    this.dragData = null;
  }
  UNSAFE_componentWillMount() {
    this.props.changeSidebarState(SidebarState.NONE);
    if (this.props.assetType === AssetType.SAVED_ITEM) {
      this.props.changeAssetType(AssetType.GRAPHIC_TEMPLATE);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.configLoaded && nextProps.configLoaded) {
      this.props.changeFooterHeight("0rem");
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const userLoggedIn = nextProps.authenticated;
    const userChanged = this.props.userId !== nextProps.userId;
    const assetsNeedUpdate = nextProps.needUpdate;
    const assetsLoading = nextProps.assetsLoading;
    const assetTypeChanged = this.props.assetType !== nextProps.assetType;

    if (this.props.initialized) {
      if (
        !nextProps.categoriesLoading &&
        ((userChanged && userLoggedIn) || assetTypeChanged)
      ) {
        this.props.getCategories(nextProps.assetType || "template");
      }

      if (
        !nextProps.filtersLoading &&
        ((userChanged && userLoggedIn) || assetTypeChanged)
      ) {
        this.props.getFilterOptions(nextProps.userId, nextProps.assetType);
      }
    }

    if (
      assetsNeedUpdate &&
      userLoggedIn &&
      nextProps.initialized &&
      !assetsLoading
    ) {
      this.props.getAssets();
    }
  }

  onDragStart = (event, data) => {
    // The three lines below are meant to clear the drag and drop payload.
    event.dataTransfer.setData("text/plain", "");
    event.dataTransfer.setData("text/html", "");
    event.dataTransfer.setData("text/uri-list", "");
    this.dragData = data;
  };

  onDragEnd = event => {
    if (
      event.clientY > 0 &&
      event.clientY < window.innerHeight &&
      event.clientX > 0 &&
      event.clientX < window.innerWidth
    ) {
      return;
    }
    if (this.dragData) {
      const data = {
        ...this.dragData
      };
      this.props.createMosObjectFromDragDrop(data.id);
      this.dragData = null;
    }
  };

  render() {
    const {
      assetList,
      assetType,
      selectedAssetId,
      toggleFavorite,
      loadAsset,
      assetsLoading,
      changePage,
      pageNumber,
      totalPages,
      reload,
      error,
      shortcuts,
      footerHeight
    } = this.props;
    return (
      <Container overflowFix>
        <MainContainer>
          <SideBar width={App.SIDEBAR_WIDTH} left>
            <GraphicTemplatesSideBarContent />
          </SideBar>
          <SubContainer>
            <StickyHeader>
              <ControlBar />
            </StickyHeader>
            <MainContent>
              <AssetList
                assetList={assetList}
                selectedAssetId={selectedAssetId}
                toggleFavorite={toggleFavorite}
                onDoubleClick={res => loadAsset(res.id)}
                loading={assetsLoading}
                reload={reload}
                error={error}
                onDragStart={
                  assetType === AssetType.GRAPHIC_MOS_OBJECT
                    ? (event, data) => {
                        this.onDragStart(event, data);
                      }
                    : null
                }
                onDragEnd={
                  assetType === AssetType.GRAPHIC_MOS_OBJECT
                    ? (event, data) => {
                        this.onDragEnd(event, data);
                      }
                    : null
                }
              />
              <PaginationContainer bottom={footerHeight}>
                <Pagination
                  nextPageShortcut={shortcuts.nextPage}
                  prevPageShortcut={shortcuts.prevPage}
                  totalPages={totalPages}
                  currentPage={pageNumber}
                  buffer={2}
                  onChange={changePage}
                />
              </PaginationContainer>
            </MainContent>
          </SubContainer>
        </MainContainer>
        <StickyFooter>
          <Footer />
        </StickyFooter>
      </Container>
    );
  }
}

TemplateLayout.defaultProps = {
  selectedAssetId: null
};

TemplateLayout.propTypes = {
  sidebar: PropTypes.string.isRequired,
  assetList: LuciPropTypes.AssetList.isRequired,
  selectedAssetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  toggleFavorite: PropTypes.func.isRequired,
  loadAsset: PropTypes.func.isRequired,
  getAssets: PropTypes.func.isRequired,
  assetsLoading: PropTypes.bool.isRequired,
  changeSidebarState: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  reload: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  userId: PropTypes.number.isRequired,
  getCategories: PropTypes.func.isRequired,
  assetType: PropTypes.string.isRequired,
  getFilterOptions: PropTypes.func.isRequired,
  authenticated: PropTypes.bool.isRequired,
  shortcuts: PropTypes.shape({
    nextPage: PropTypes.arrayOf(PropTypes.string),
    prevPage: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  footerHeight: PropTypes.string.isRequired,
  changeFooterHeight: PropTypes.func.isRequired,
  configLoaded: PropTypes.bool.isRequired,
  initialized: PropTypes.bool.isRequired,
  changeAssetType: PropTypes.func.isRequired,
  createMosObjectFromDragDrop: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  sidebar: state.app.sidebar,
  authenticated: state.auth.authenticated,
  assetList: state.assets.assetList,
  userId: state.auth.user.userId,
  assetsLoading: state.assets.assetsLoading,
  needUpdate: state.assets.needUpdate,
  contextList: state.assets.contextList,
  categoryList: state.assets.categoryList,
  categoriesInitialized: state.assets.categoriesInitialized,
  filtersInitialized: state.assets.filtersInitialized,
  selectedAssetId: state.asset.selectedAssetId,
  pageNumber: state.assets.pageNumber,
  totalPages: state.assets.totalPages,
  error: state.assets.error,
  assetType: state.assets.assetType,
  shortcuts: state.keyShortcuts.shortcuts,
  filterList: state.assets.filterList,
  categoriesLoading: state.assets.categoriesLoading,
  filtersLoading: state.assets.filtersLoading,
  footerHeight: state.app.footerHeight,
  configLoaded: state.app.configLoaded,
  initialized: state.app.initialized
});

const mapActionCreators = {
  toggleFavorite: assetsActions.toggleFavorite,
  loadAsset: assetActions.loadAsset,
  getAssets: assetsActions.getAssets,
  reload: assetsActions.reload,
  changeSidebarState: appActions.changeSidebarState,
  changePage: assetsActions.changePage,
  getFilterOptions: assetsActions.getFilterOptions,
  getCategories: assetsActions.getCategories,
  changeFooterHeight: appActions.changeFooterHeight,
  changeAssetType: assetsActions.changeAssetType,
  createMosObjectFromDragDrop: assetActions.createMosObjectFromDragDrop
};

export default connect(mapStateToProps, mapActionCreators)(TemplateLayout);



// WEBPACK FOOTER //
// ./app/layouts/TemplateLayout.js